<script>
import ManageList from '@/pages/manage/_type/index.vue'
import { http } from '@/services/http.js'

export default {
  name: 'ManageListStatusTransition',
  components: {
    NewButton: {render() {}},
  },
  extends: ManageList,
  props: {
    token: String,
    id: String,
    backClass: {
      default: null
    },
    fields: {
      type: Array,
      default: () => ([
        {key: 'transition', sortable: true},
        {key: 'notes', sortable: true, autoshow: 'sm'},
        {key: 'createdOn', sortable: true, autoshow: 'sm'},
      ]),
    },
    limitOptions: {
      default: undefined,
    },
    ordering: {
      default: '-createdOn',
    },
  },
  computed: {
    title() {
      return `Status Transitions`
    },
  },
  methods: {
    async fetchItems() {
      this.loading = true
      const data = await http.get(`/api/artist-identity/${this.token}/${this.type}/${this.id}/status-transitions/`, {params: this.$route.query})
        .then(response => response.data)
        .finally(() => this.loading = false)
      this.items = data.data
      this.total = data.count
      this.limit_ = data.limit
    },
    getTo(item) {
      return { path: item.token, append: true }
    },
  },
}
</script>
